module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/funabashi_ekimae_point3_1-0b2a2d3eedcbfd188883d724bd53dfd9.jpg";